import { useContext, useState} from 'react'
import Card from '../ui/Card'
import ReviewComponent from './reviewComponent'
import CommonService from '../../services/CommonService'
import { UserContext } from '../../UseContext'
import { toast } from 'react-toastify'
import { useParams } from 'react-router-dom'
import { renderToString } from 'react-dom/server'
import AdtrService from '../../services/AdtrService'
import EditReasonModal from '../reports/editReasonModal'
import ReportsService from '../../services/ReportsService'
import swal from 'sweetalert'
const AdtrReview = (props) => {
    const {adtrDependenciesData, contact} = props;
    const adtrInfo = adtrDependenciesData.adtrInfo;
    const adtrId = adtrInfo.adtrId;
    //const history = useNavigate();
    const params = useParams();
    const cdiacNo = params.cdiac;
    const user = useContext(UserContext);
    const [showEditReasonModal, setShowEditReasonModal] = useState(false);

    const updateFinalAdtr = async() => {
        const html = renderToString(<ReviewComponent adtrDependenciesData={adtrDependenciesData} contact={contact} />)

        let obj = {
            "msgId": null,
            "sysId": null,
            "opr": "updateFinalAdtr",
            "hdrStruct": null,
            "queryParam": null,
            "reqData": {
                "id": adtrId,
                "env": "E",
                "adtr":{
                    "finalSaleid" : adtrInfo.finalSaleId,
                    "lastUpdateUser": CommonService.getUserName(user),
                    "emailId": user,
                    "statusFlag" : "S"
                },
                "reportType" : "ADTR",
                "html" : html,
                "cdiacNbr" : cdiacNo
            }
        };
        AdtrService.updateFinalAdtr(obj)
        .then((res) => res)
        .then((result) => {
            if (result.data.errors && result.data.errors.length > 0){
                toast.error(result.data.errors[0].message);
            }
            else{
                if(result.data && result.data.responses[0]) {
                    var base64EncodedPDF = result.data.responses[0].pdf;
                    var arrrayBuffer = CommonService.base64ToArrayBuffer(base64EncodedPDF); 
                    var blob = new Blob([arrrayBuffer], {type: "application/pdf"});
                    var url = window.URL.createObjectURL(blob);
                    window.open(url);
                } 
                toast.success("Annual Debt Transparency Submitted successfully!");
            }
        });
    }

    const validateRequiredFields = async() => {
        let obj = {
            "msgId": null,
            "sysId": null,
            "opr": "validateFinalAdtr",
            "hdrStruct": null,
            "queryParam": null,
            "reqData": {
                //Change Later
                "id": adtrId
            }
        };
        AdtrService.validateAdtr(obj)
        .then((res) => res)
        .then((result) => {
            if (result.data.errors && result.data.errors.length > 0){
                toast.error(result.data.errors[0].message)
            }
            else{
                if(result.data.responses[0].length > 0) {
                  let alertMessage = "";
                  result.data.responses[0].forEach(item => {
                    alertMessage +=  "- " + item.message + "\n";
                  });
                  alert(alertMessage);
                } else {
                    if(adtrInfo.statusFlag === "R") {
                        swal({
                            text: "Do you want to re-edit this record?",
                            icon: "warning",
                            buttons: [true, 'Yes'],
                            closeOnClickOutside: false
                          })
                          .then((confirm) => {
                            if (confirm) {
                                setShowEditReasonModal(true)
                            } 
                          });
                    } else {
                        updateFinalAdtr()
                    }
                }
            }

        });
    }

    const saveEditReason = (editReason) => {
        let obj ={
             "msgId": null,
             "sysId": null,
             "opr": "postEditReason",
             "hdrStruct": null,
             "queryParam": null,
             "reqData": {
                 "editReason" : {
                     "editReasonCodeId" : editReason.editReasonCodeId,
                     "comment" : editReason.comment,
                     "adtrId" : adtrInfo.adtrId,
                     "createUser" : CommonService.getUserName(user)
                 }
             }
         } 

         ReportsService.saveEditReason(obj)
         .then((res) => res)
         .then((result) => {
             if(result.data.errors.length > 0) {
                toast.error(result.data.errors[0].message);
             } else {
                toast.success("Edit Reason saved successfully!")
                updateFinalAdtr()
             }
         });
    }

    const validateAdtrReport = () => {
        props.toggleWidget('review');
        validateRequiredFields()
    }

    return (
        <Card>
            <div className="form">
                <div className="row">
                    <div className="col-sm-8 col-12">
                        <h3>Annual Debt Transparency Report</h3>
                    </div>
                </div>
                <ReviewComponent adtrDependenciesData={adtrDependenciesData} contact={contact}/>
                <div className="btn-div">
                <button className="fright custom-button" type="button" onClick={()=>validateAdtrReport()}>Validate & Submit</button>
                </div>
            
            </div>
            {showEditReasonModal && <EditReasonModal  onModalClose={()=>setShowEditReasonModal(false)} handleSave={saveEditReason} cdiacReasonCode="ADTER"/>}
        </Card>
    )
}

export default AdtrReview
